// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
  background-color: #1a1a2e;
  color: #eee;
  padding: 20px;
}

#app {
  max-width: 1200px;
  margin: 0 auto;
}

header {
  text-align: center;
  margin-bottom: 30px;
}

h1 {
  font-size: 2.5rem;
  color: #0f3460;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.mute-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: transparent;
  border: 2px solid #0f3460;
  padding: 8px 16px;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.mute-btn:hover {
  background-color: #0f3460;
  border-color: #4ecca3;
}

.mute-btn.muted {
  border-color: #e74c3c;
  color: #e74c3c;
}

#game-info {
  margin-top: 20px;
}

#current-player,
#game-status {
  font-size: 1.2rem;
  margin: 10px 0;
}

.phase {
  transition: opacity 0.3s ease;
}

.phase.active {
  display: block;
}

.phase.hidden {
  display: none;
}

#setup-phase {
  text-align: center;
  padding: 40px;
}

.setup-container {
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
  align-items: flex-start;
}

#ship-placement-controls {
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 250px;
}

#ship-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ship-btn {
  background-color: #0f3460;
  color: white;
  border: 2px solid transparent;
  padding: 12px 24px;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.ship-btn:hover {
  background-color: #16213e;
}

.ship-btn.active {
  border-color: #4ecca3;
  background-color: #16213e;
}

.ship-btn.placed {
  background-color: #2d3748;
  cursor: not-allowed;
  opacity: 0.6;
}

.ship-btn.dragging {
  opacity: 0.5;
  cursor: grabbing;
}

.ship-btn:not(.placed) {
  cursor: grab;
}

.instruction {
  font-size: 0.9rem;
  color: #aaa;
  margin-bottom: 10px;
  font-style: italic;
}

.cell.drag-over {
  background-color: #4ecca3;
  border: 2px solid #3dbb8f;
}

.cell.drag-invalid {
  background-color: #e74c3c;
  border: 2px solid #c0392b;
}

button {
  background-color: #0f3460;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

button:hover:not(:disabled) {
  background-color: #16213e;
}

button:disabled {
  background-color: #2d3748;
  cursor: not-allowed;
  opacity: 0.6;
}

button.hidden {
  display: none;
}

#toggle-orientation {
  background-color: #4ecca3;
  color: #1a1a2e;
  font-weight: bold;
}

#toggle-orientation:hover {
  background-color: #3dbb8f;
}

.game-controls {
  text-align: center;
  margin-bottom: 20px;
}

#end-game-btn {
  background-color: #e74c3c;
  color: white;
  font-size: 1rem;
  padding: 10px 20px;
}

#end-game-btn:hover {
  background-color: #c0392b;
}

.turn-controls {
  text-align: center;
  margin-top: 30px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#confirm-turn-btn {
  background-color: #4ecca3;
  color: #1a1a2e;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 15px 30px;
  animation: slideIn 0.4s ease-out;
}

#confirm-turn-btn:hover {
  background-color: #3dbb8f;
}

#confirm-turn-btn.hidden {
  display: none;
  animation: slideOut 0.3s ease-in;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.gameboards-container {
  display: flex;
  justify-content: space-around;
  gap: 40px;
  flex-wrap: wrap;
}

.gameboard-wrapper {
  text-align: center;
}

.gameboard-wrapper h3 {
  margin-bottom: 15px;
  font-size: 1.5rem;
}

.gameboard {
  display: grid;
  grid-template-columns: repeat(10, 40px);
  grid-template-rows: repeat(10, 40px);
  gap: 2px;
  background-color: #16213e;
  padding: 5px;
  border-radius: 5px;
}

.cell {
  width: 40px;
  height: 40px;
  background-color: #0f3460;
  border: 1px solid #1a1a2e;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.cell:hover {
  background-color: #16213e;
}

.cell.ship {
  background-color: #4a5568;
}

.cell.hit {
  background-color: #e74c3c;
}

.cell.miss {
  background-color: #3498db;
}

.cell.preview {
  background-color: #4ecca3;
}

.cell.preview-invalid {
  background-color: #e74c3c;
}

#game-over-phase {
  text-align: center;
  padding: 40px;
}

#winner-message {
  font-size: 1.5rem;
  margin: 20px 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: Arial, sans-serif;\r\n  background-color: #1a1a2e;\r\n  color: #eee;\r\n  padding: 20px;\r\n}\r\n\r\n#app {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\nheader {\r\n  text-align: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\nh1 {\r\n  font-size: 2.5rem;\r\n  color: #0f3460;\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.mute-btn {\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 20px;\r\n  background-color: transparent;\r\n  border: 2px solid #0f3460;\r\n  padding: 8px 16px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.mute-btn:hover {\r\n  background-color: #0f3460;\r\n  border-color: #4ecca3;\r\n}\r\n\r\n.mute-btn.muted {\r\n  border-color: #e74c3c;\r\n  color: #e74c3c;\r\n}\r\n\r\n#game-info {\r\n  margin-top: 20px;\r\n}\r\n\r\n#current-player,\r\n#game-status {\r\n  font-size: 1.2rem;\r\n  margin: 10px 0;\r\n}\r\n\r\n.phase {\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.phase.active {\r\n  display: block;\r\n}\r\n\r\n.phase.hidden {\r\n  display: none;\r\n}\r\n\r\n#setup-phase {\r\n  text-align: center;\r\n  padding: 40px;\r\n}\r\n\r\n.setup-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 60px;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n}\r\n\r\n#ship-placement-controls {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  min-width: 250px;\r\n}\r\n\r\n#ship-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.ship-btn {\r\n  background-color: #0f3460;\r\n  color: white;\r\n  border: 2px solid transparent;\r\n  padding: 12px 24px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.ship-btn:hover {\r\n  background-color: #16213e;\r\n}\r\n\r\n.ship-btn.active {\r\n  border-color: #4ecca3;\r\n  background-color: #16213e;\r\n}\r\n\r\n.ship-btn.placed {\r\n  background-color: #2d3748;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.ship-btn.dragging {\r\n  opacity: 0.5;\r\n  cursor: grabbing;\r\n}\r\n\r\n.ship-btn:not(.placed) {\r\n  cursor: grab;\r\n}\r\n\r\n.instruction {\r\n  font-size: 0.9rem;\r\n  color: #aaa;\r\n  margin-bottom: 10px;\r\n  font-style: italic;\r\n}\r\n\r\n.cell.drag-over {\r\n  background-color: #4ecca3;\r\n  border: 2px solid #3dbb8f;\r\n}\r\n\r\n.cell.drag-invalid {\r\n  background-color: #e74c3c;\r\n  border: 2px solid #c0392b;\r\n}\r\n\r\nbutton {\r\n  background-color: #0f3460;\r\n  color: white;\r\n  border: none;\r\n  padding: 12px 24px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\nbutton:hover:not(:disabled) {\r\n  background-color: #16213e;\r\n}\r\n\r\nbutton:disabled {\r\n  background-color: #2d3748;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\nbutton.hidden {\r\n  display: none;\r\n}\r\n\r\n#toggle-orientation {\r\n  background-color: #4ecca3;\r\n  color: #1a1a2e;\r\n  font-weight: bold;\r\n}\r\n\r\n#toggle-orientation:hover {\r\n  background-color: #3dbb8f;\r\n}\r\n\r\n.game-controls {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n#end-game-btn {\r\n  background-color: #e74c3c;\r\n  color: white;\r\n  font-size: 1rem;\r\n  padding: 10px 20px;\r\n}\r\n\r\n#end-game-btn:hover {\r\n  background-color: #c0392b;\r\n}\r\n\r\n.turn-controls {\r\n  text-align: center;\r\n  margin-top: 30px;\r\n  min-height: 60px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n#confirm-turn-btn {\r\n  background-color: #4ecca3;\r\n  color: #1a1a2e;\r\n  font-weight: bold;\r\n  font-size: 1.1rem;\r\n  padding: 15px 30px;\r\n  animation: slideIn 0.4s ease-out;\r\n}\r\n\r\n#confirm-turn-btn:hover {\r\n  background-color: #3dbb8f;\r\n}\r\n\r\n#confirm-turn-btn.hidden {\r\n  display: none;\r\n  animation: slideOut 0.3s ease-in;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideOut {\r\n  from {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n  to {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n}\r\n\r\n.gameboards-container {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  gap: 40px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.gameboard-wrapper {\r\n  text-align: center;\r\n}\r\n\r\n.gameboard-wrapper h3 {\r\n  margin-bottom: 15px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.gameboard {\r\n  display: grid;\r\n  grid-template-columns: repeat(10, 40px);\r\n  grid-template-rows: repeat(10, 40px);\r\n  gap: 2px;\r\n  background-color: #16213e;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.cell {\r\n  width: 40px;\r\n  height: 40px;\r\n  background-color: #0f3460;\r\n  border: 1px solid #1a1a2e;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.cell:hover {\r\n  background-color: #16213e;\r\n}\r\n\r\n.cell.ship {\r\n  background-color: #4a5568;\r\n}\r\n\r\n.cell.hit {\r\n  background-color: #e74c3c;\r\n}\r\n\r\n.cell.miss {\r\n  background-color: #3498db;\r\n}\r\n\r\n.cell.preview {\r\n  background-color: #4ecca3;\r\n}\r\n\r\n.cell.preview-invalid {\r\n  background-color: #e74c3c;\r\n}\r\n\r\n#game-over-phase {\r\n  text-align: center;\r\n  padding: 40px;\r\n}\r\n\r\n#winner-message {\r\n  font-size: 1.5rem;\r\n  margin: 20px 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
